import(/* webpackMode: "eager" */ "/home/admin/prodmob-webapp/mob-webapp/src/app/[locale]/b2b/page.tsx");
